if (!customElements.get("product-info")) {
	customElements.define(
		"product-info",
		class ProductInfo extends HTMLElement {
			abortController = undefined;
			onVariantChangeUnsubscriber = undefined;
			cartUpdateUnsubscriber = undefined;
			pendingRequestUrl = null;
			preProcessHtmlCallbacks = [];
			postProcessHtmlCallbacks = [];

			constructor() {
				super();

				// 合并货号 所有产品 json 数据
				const jsonEl = this.querySelector('#_products_json');
				const jsonContent = jsonEl.textContent || jsonEl.innerHTML;

				// 整理数据，生成合法的json
				const arrJson = jsonContent.split('__qlComma__,');
				let productsJson = [];
				arrJson.forEach(item => {
					const temp = item.trim();
					if(temp) productsJson.push(temp);
				});

				productsJson = '{' + productsJson.join(',') + '}';

				const json = productsJson && JSON.parse(productsJson);
				if(json) this.productsJson = json;

				// 合并货号所有variants
				const variantsEl = this.querySelector('#_hb_all_variants');
				const variantsContent = variantsEl.textContent || variantsEl.innerHTML;
				const variantsJson = variantsContent && JSON.parse(variantsContent);
				if(variantsJson) this.allVariantsJson = variantsJson;

				// 合并货号所有媒体图
				const mediasEl = this.querySelector('#_hb_all_media');
				const mediasContent = mediasEl.textContent || mediasEl.innerHTML;
				const mediasJson = mediasContent && JSON.parse(mediasContent);
				if(mediasJson) this.allMediasJson = mediasJson;
			}

			get variantSelectors() {
				return this.querySelector("variant-picker");
			}

			get productMedia() {
				return this.querySelector(
					`[id^="MediaGallery-${this.dataset.section}"]`
				);
			}

			get sectionId() {
				return this.dataset.originalSection || this.dataset.section;
			}

			get productUrl() {
				return this.dataset.url;
			}

			get productId() {
				return this.getAttribute("data-product-id");
			}

			get pickupAvailability() {
				return this.querySelector(`pickup-availability`);
			}

			get inventoryStatus() {
				return this.querySelector(`#Inventory-${this.dataset.section}`);
			}

			get sku() {
				return this.querySelector(`#Sku-${this.dataset.section}`);
			}

			get availability() {
				return this.querySelector(`#Availability-${this.dataset.section}`);
			}

			get enableVariantGroupImages() {
				return this.dataset.enableVariantGroupImages === "true" || false;
			}

			get disableDefaultSelectVariant() {
				return this.dataset.disableDefaultSelectVariant === "true" || false;
			}

			get productForm() {
				return this.querySelector("product-form");
			}

			get quantityInput() {
				return this.querySelector("quantity-input input");
			}

			// 获取 选中variant json 数据
			getSelectedVariant(productInfoNode) {
				const selectedVariant = productInfoNode.querySelector(
					"variant-picker [data-selected-variant]"
				)?.innerHTML;
				return !!selectedVariant ? JSON.parse(selectedVariant) : null;
			}

			// 通过json数据获取选中的变体variant
			getHuohaoSelectedVariant(selectedOptionValues) {
				const variants = this.productData.variants;
				const filterVariants =  variants.filter((variant) =>{
					return selectedOptionValues.every((val, i) => {
						const option = 'option' + (i + 1);
						return variant[option] === val;
					})

				});
				return filterVariants.length > 0 ? filterVariants[0] : null;
			}

			getVariantGroupImages() {
				return (
					JSON.parse(
						this.querySelector('#VariantGroupImages[type="application/json"]')
							.textContent
					) || {}
				);
			}

			getProductOptionByName(optionName, productData) {
				for (var i = 0; i < productData.options.length; i++) {
					var option = productData.options[i];
					if (option["name"] === optionName) {
						return option;
					}
				}
				return null;
			}

			async getProductData() {
				try {
					const response = await fetch(this.dataset.productUrl + ".js");
					if (!response.ok) {
						throw new Error(
							`Bad HTTP status of the request (${response.status}).`
						);
					}
					const data = await response.json();
					return data;
				} catch (err) {
					console.log(
						`An error occurred while processing the request. Error message: ${err.message}`
					);
				}
			}

			async init() {
				this.onVariantChangeUnsubscriber = window.FoxThemeEvents.subscribe(
					PUB_SUB_EVENTS.optionValueSelectionChange,
					this.handleOptionValueChange.bind(this)
				);

				if (this.enableVariantGroupImages) {
					this.variantGroupImages = this.getVariantGroupImages();
				}

				this.addEventListener("product-media:loaded", (evt) => {
					if (this.enableVariantGroupImages && this.variantGroupImages.enable) {
						this.updateMedia(evt.detail.currentVariant);
					}
				});

				this.productData = await this.getProductData();
				this.Notification = window.FoxTheme.Notification;

				this.mediaByVariantColor = [];
				let allVariants = this.productData?.variants ?? [];
				if(this.allVariantsJson.length > 0) allVariants = this.allVariantsJson ?? [];
				allVariants.forEach((variant) => {
					if (variant.featured_media) {
						if (!this.mediaByVariantColor[variant.featured_media.id]) {
							this.mediaByVariantColor[variant.featured_media.id] = [];
						}
						// 拿到当前选定swatch的选项值
						this.mediaByVariantColor[variant.featured_media.id].push(variant.options[0]);
					}
				});

				const variantsPickerEl = this.querySelector(`variant-picker#variant-picker-${this.dataset.section}`);
				const huohaoSelectedOptionValues = variantsPickerEl.huohaoSelectedOptionValues;
				const selectedVariant = this.getHuohaoSelectedVariant(huohaoSelectedOptionValues);
				
				if(selectedVariant){
					this.updateMedia(selectedVariant);
					this.setOotd(selectedVariant);
					// 更新库存是否低于阈值文本  和 加购按钮文本
					this.updateInventory(selectedVariant);
					// 更新SKU
					this.updateSku(selectedVariant);
					this.currentVariant = selectedVariant;
					// 更新分享链接 和 Ask question
					this.updateShareLink(selectedVariant);
					// 更新模特数据
					this._ql_modal_data(this.productData, selectedVariant);
				}								

				document.addEventListener("unmatchMobile", () => {
					this.productMedia && this.productMedia.currentVariant
						&& this.updateMedia(this.productMedia.currentVariant)
				});

				if (this.productData && this.disableDefaultSelectVariant) {
					this.handleDisableDefaultSelectVariant();
				}
			}

			initializeProductSwapUtility() {
				this.postProcessHtmlCallbacks.push((newNode) => {
					__reInitTooltip(newNode);
					window?.Shopify?.PaymentButton?.init();
					window?.ProductModel?.loadShopifyXR();
				});
			}

			initQlthProductSwap() {
				this.addEventListener("click", async (event) => {
					const listItem = event.target.closest(".options--qlth li");
					if (!listItem) return;

					const link = listItem.querySelector(".ql_qlth");
					if (!link || link.classList.contains("active")) return;

					event.preventDefault();
					const handle = link.dataset.handle;
					if (!handle) return;

					if (this.dataset.qlthSwapping === "true") return;
					this.dataset.qlthSwapping = "true";

					const sectionId = this.sectionId;
					const rootUrl = window.FoxThemeSettings?.routes?.root || "";
					const productUrl = `${rootUrl}/products/${handle}`.replace(/\/{2,}/g, "/");

					link.classList.add("is-loading");

					try {
						const response = await fetch(`${productUrl}?section_id=${sectionId}`, {
							headers: {
								"X-Requested-With": "XMLHttpRequest",
							},
						});

						if (!response.ok) {
							throw new Error(`Failed to load product section: ${response.status}`);
						}

						const responseText = await response.text();
						const html = new DOMParser().parseFromString(responseText, "text/html");
						const newProductInfo = html.querySelector(`product-info[data-section="${sectionId}"]`);

						if (newProductInfo) {
							if (this.dataset.updateUrl === "true") {
								window.history.replaceState({}, "", productUrl);
							}
							HTMLUpdateUtility.viewTransition(
								this,
								newProductInfo,
								this.preProcessHtmlCallbacks,
								this.postProcessHtmlCallbacks
							);
						}
					} catch (error) {
						console.error("QLTH product swap error:", error);
					} finally {
						this.dataset.qlthSwapping = "false";
						link.classList.remove("is-loading");
					}
				});
			}

			connectedCallback() {
				this.initializeProductSwapUtility();
				this.init();
				this.initQlthProductSwap();

				this.initQuantityHandlers();
			}

			disconnectedCallback() {
				this.onVariantChangeUnsubscriber();
				this.cartUpdateUnsubscriber?.();
			}

			handleDisableDefaultSelectVariant() {
				const stickyAtc = document.querySelector(".sticky-atc-bar");
				let urlParams = new URLSearchParams(window.location.search);
				if (urlParams.has("variant")) return;

				if (stickyAtc) {
					stickyAtc.classList.add("f-hidden");
				}

				this.inventoryStatus && this.inventoryStatus.setAttribute("hidden", "");
				this.sku && this.sku.classList.add("hidden");
				this.availability && this.availability.classList.add("hidden");

				let isVariantChange = false;
				this.pickerFields = this.querySelectorAll("[data-picker-field]");

				this.pickerFields &&
					this.pickerFields.forEach((field) => {
						let optionName = field.dataset.optionName;
						let optionInfo = this.getProductOptionByName(
							optionName,
							this.productData
						);

						if (optionInfo && optionInfo.values.length > 1) {
							isVariantChange = true;
							let pickerType = field.dataset.pickerField;
							switch (pickerType) {
								case "select":
									let selectBox = field.querySelector("select");
									let option = document.createElement("option");
									option.text = this.dataset.variantOptionNoneText;
									option.setAttribute("disabled", "");
									option.setAttribute("selected", "");

									selectBox.add(option, 0);
									break;
								default:
									let checkedInputs = field.querySelectorAll("input:checked");
									checkedInputs &&
										checkedInputs.forEach(function (input) {
											input.removeAttribute("checked");
										});
									break;
							}

							field.dataset.selectedValue = "";
							if (field.querySelector(".selected-value")) {
								field.querySelector(".selected-value").textContent = "";
							}
						}
					});

				if (isVariantChange) {
					document
						.querySelectorAll(
							`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
						)
						.forEach((productForm) => {
							const input = productForm.querySelector('input[name="id"]');
							input.value = "";
						});

					const atcButton = this.querySelector('[name="add"]');
					const buyNowButton = this.querySelector(
						".shopify-payment-button__button"
					);

					atcButton.addEventListener(
						"click",
						this.handleDisableDefaultSelectVariantMessage.bind(this)
					);
					buyNowButton &&
						buyNowButton.addEventListener(
							"click",
							this.handleDisableDefaultSelectVariantMessage.bind(this)
						);
				}
			}

			handleDisableDefaultSelectVariantMessage(evt) {
				if (!this.currentVariant) {
					evt.preventDefault();
					this.pickerFields &&
						this.pickerFields.forEach((pickerField) => {
							if ("" === pickerField.dataset.selectedValue) {
								pickerField
									.closest(".variant-picker__field-wrapper")
									.classList.add("is-error");
							}
						});

					this.Notification.show({
						target: this.productForm,
						method: "appendChild",
						type: "warning",
						last: 3000,
						message: this.dataset.variantSelectionNeededText,
					});
				}
			}

			async handleOptionValueChange({
				data: { event, target, huohaoSelectedOptionValues },
			}) {
				if (!this.contains(event.target)) return;

				// 重写---------------------------------------
				const el = event.target;
				const productHandle = el.getAttribute('data-handle') || el.querySelector('input[data-handle]:checked')?.dataset.handle;
				if(productHandle && this.dataset.productUrl !== '/products/' + productHandle){
					this.dataset.productUrl = '/products/' + productHandle;
					if(this.productsJson && this.productsJson[productHandle]){
						this.productData = this.productsJson[productHandle].product;
					}else{
						this.productData = await this.getProductData();
					}

					// 更新标题 和 产品产品描述
					if(this.querySelector('.f-product-single__title')){
						this.querySelector('.f-product-single__title').innerHTML = this.productData.title;
					}
					if(this.querySelector('.collapsible__content-inner[data-description-content]')){
						this.querySelector('.collapsible__content-inner[data-description-content]').innerHTML = this.productData.description;
					}
					// block: description
					if(this.querySelector('.f-product__description')){
						this.querySelector('.f-product__description').innerHTML = this.productData.description;
					}if(this.querySelector('.btn-view-details')){
						this.querySelector('.btn-view-details').href = this.dataset.productUrl;
					}
				}
				

				const selectedVariant = this.getHuohaoSelectedVariant(huohaoSelectedOptionValues);

				// 切换为选中的元素
				this.querySelector(`#${target.id}`)?.focus();

				// 更新option选中文本 label
				this.updateOptionLabel(target);
				
				if (!selectedVariant) {
					this.setUnavailable();
					return;
				}

				this.pickupAvailability?.update(selectedVariant);

				// 更新url
				this.updateURL( this.dataset.productUrl, selectedVariant?.id);
				this.updateShareUrl(selectedVariant?.id);
				
				// 更新加购按钮variant id
				this.updateVariantInputs(selectedVariant?.id);

				this.toolTip = __reInitTooltip(this);

				// 更新媒体图
				this.updateMedia(selectedVariant);

				// 更新ootd
				this.setOotd(selectedVariant);

				// 更新价格
				this.updatePrice(selectedVariant)
				
				// 更新库存是否低于阈值文本  和 加购按钮文本
				this.updateInventory(selectedVariant);

				// 更新SKU
				this.updateSku(selectedVariant);

				this.currentVariant = selectedVariant;
				document.dispatchEvent(
					new CustomEvent("variant:changed", {
						detail: {
							variant: this.currentVariant,
						},
					})
				);

				// 更新分享链接 和 Ask question
				this.updateShareLink(selectedVariant);

				// 更新库存状态
				this.updateAvailability(target, selectedVariant);

				// 更新模特数据
				this._ql_modal_data(this.productData, selectedVariant);


				// 更新底部加购弹窗
				this.updateStickyAtcBar(selectedVariant);

				//------------------------------------------------
				// const productUrl =
				// 	target.dataset.productUrl ||
				// 	this.pendingRequestUrl ||
				// 	this.dataset.productUrl;
				// const shouldSwapProduct = this.dataset.productUrl !== productUrl;
				// const shouldFetchFullPage =
				// 	this.dataset.updateUrl === "true" && shouldSwapProduct;

				// this.renderProductInfo({
				// 	requestUrl: this.buildRequestUrlWithParams(
				// 		productUrl,
				// 		selectedOptionValues,
				// 		shouldFetchFullPage
				// 	),
				// 	targetId: target.id,
				// 	callback: shouldSwapProduct
				// 		? this.handleSwapProduct(productUrl, shouldFetchFullPage)
				// 		: this.handleUpdateProductInfo(productUrl),
				// });
			}

			// 更新底部加购弹窗
			updateStickyAtcBar(variant){
				const check = setInterval(() => {
					const container = document.querySelector('sticky-atc-bar');
					const variantOption = this.querySelector(`#Variants-${this.sectionId} option[value="${variant.id}"]`);
					if(container){
					  const selects = container.querySelectorAll('select[name="id"]');
					  const imgEls = container.querySelectorAll('responsive-image img');
					  const atcBarEl = container.querySelector('[name="product-id"]');
					  atcBarEl && (atcBarEl.value = variant.id);
					  selects.forEach((i) => {
						const optionEl = i.querySelector(`option[value="${variant.id}"]`);
						
						if(!optionEl) return;
						i.value = variant.id;
					  });

					  imgEls.forEach((el) => {
						if(!el || !variant.featured_image) return;
						el.src = variant.featured_image.src;
						if(variantOption) el.srcset = variantOption.dataset.imageSrcset;
					  });
					  clearInterval(check);
					}
					
				});
			}

			// 更新option选中文本 label
			updateOptionLabel(target){
				const variantPicker = this.querySelector(`#variant-picker-${this.sectionId}`);
				if(!variantPicker) return;


				Array.from(
					variantPicker.querySelectorAll(
					  "select, .variant-picker__option-values"
					),
					(element, index) => {
						const parentNode = element.closest('.variant-picker__field');
						switch (element.tagName) {
							case "SELECT":
								if(parentNode.querySelector(".selected-value")){
									parentNode.querySelector(".selected-value").textContent = element.dataset.optionValue;
								}
								break;
							case "DIV":

								const el = element.querySelector("input:checked");
								if(el){
									const value = el.dataset.optionValue;
									if(parentNode.querySelector(".selected-value")){
										parentNode.querySelector(".selected-value").textContent = value;
									}
								}else{
									if(parentNode.querySelector(".selected-value")){
										parentNode.querySelector(".selected-value").textContent = '';
									}
								}
								break;
						}
					}
				);


				// const value = target.dataset.optionValue;
				// const els = variantPicker.querySelectorAll('.variant-picker__field');
				// els.forEach((item) => {
				// 	if (item.querySelector(".selected-value")) {
				// 		item.querySelector(".selected-value").textContent = "";
				// 	}
				// });

				// const el = target.closest('.variant-picker__field');
				// if(el){
				// 	if(el.querySelector(".selected-value")){
				// 		el.querySelector(".selected-value").textContent = value;
				// 	}
				// }
			}

			/** 更新各个option值的库存状态
			 * 1. 如果某个option1的值跟任意option2(如果有)和option3(如果有)的值搭配对应的variant都不可用，则这个option1的值不可用；
			 * 1.1 如果是颜色 并且颜色是option1属性，则该判断在liquid初次加载时已做判断，而且后期不会变化，所以此处不做处理。
			 * 2. 如果某个option2的值跟选中的option1 + 任意option3(如果有)对应的variant都不可以，那么这个option2的值不可用；
			 * 3.  如果某个option3 + 选中的option1 + 选中的option2对应的variant不可用，这这个option3对应的值不可用
			 */
			updateAvailability(target, variant){
				const variantPicker = this.querySelector(`#variant-picker-${this.sectionId}`);
				if(!variantPicker || !variant) return;

				// 当前选中的各个option值
				const [selected1, selected2] = variant.options;

				const selectProductId = variant.featured_image?.product_id;
				const arrOptionName =  window.FoxThemeSettings.color_swatches_trigger?.split(',');

				// 判断每个option值 的 库存状态
				const fields = variantPicker.querySelectorAll('.variant-picker__field-wrapper .variant-picker__field');
				fields.forEach((field) => {
					const position = field.getAttribute('data-option-position');
					const name = field.getAttribute('data-option-name');
					if(!position) return;

					// 不判断颜色. liquid初次加载时已做判断
					if(arrOptionName.includes(name) && parseInt(position, 10) === 1){
						return;
					}

					const inputs = field.querySelectorAll('input');

					if(parseInt(position, 10) === 1){
						inputs.forEach((input) => {
							const testValue = input.dataset.optionValue;
							const testProductId = input.dataset.productId;

							const hasAnyAvailable = this.allVariantsJson.some(this_variant => {
								// 产品id判断 防止合并货号有相同颜色的情况
								if(testProductId && 
									this_variant.featured_image  && 
									this_variant.featured_image.product_id &&
									this_variant.featured_image.product_id !== testProductId
								) return false;

								if(this_variant.option1 !== testValue) return false;

								return !!this_variant.available;
							});
					
							this.setInputAvailability(input, hasAnyAvailable);
						});
					}else if(parseInt(position, 10) === 2){
						inputs.forEach((input) => {
							const testValue = input.dataset.optionValue;

							// 如果还没有选中的 option1，则默认库存状态为true（给用户自由选择）
							if(!selected1){
								this.setInputAvailability(input, true);
								return;
							}

							const hasAnyAvailable = this.allVariantsJson.some(this_variant => {
								// 产品id判断 防止合并货号有相同颜色的情况
								if(selectProductId && 
									this_variant.featured_image  && 
									this_variant.featured_image.product_id &&
									this_variant.featured_image.product_id !== selectProductId
								) return false;

								if(this_variant.option1 !== selected1) return false;
								if(this_variant.option2 !== testValue) return false;

								return !!this_variant.available;
							});
					
							this.setInputAvailability(input, hasAnyAvailable);
						});
					}else if(parseInt(position, 10) === 3){
						inputs.forEach((input) => {
							const testValue = input.dataset.optionValue;

							// 如果还没有选中的 option1/option2，则默认库存状态为true（给用户自由选择）
							if(!selected1 || !selected2){
								this.setInputAvailability(input, true);
								return;
							}

							const hasAnyAvailable = this.allVariantsJson.some(this_variant => {
								// 产品id判断 防止合并货号有相同颜色的情况
								if(selectProductId && 
									this_variant.featured_image  && 
									this_variant.featured_image.product_id &&
									this_variant.featured_image.product_id !== selectProductId
								) return false;

								if(this_variant.option1 !== selected1) return false;
								if(this_variant.option2 !== selected2) return false;
								if(this_variant.option3 !== testValue) return false;

								return !!this_variant.available;
							});
					
							this.setInputAvailability(input, hasAnyAvailable);
						});
					}

				});
			}

			setInputAvailability(input, isAvailable){
				// 根据 hasAvailableVariant 来控制状态
				if (isAvailable) {
					input.closest('.variant-picker__option')?.classList.remove('variant-picker__option--soldout');
				} else {
					// 如果没有任何可用变体，说明这个选项值在当前上下文下是「售罄」状态
					input.closest('.variant-picker__option')?.classList.add('variant-picker__option--soldout');
				}
			}


			// 更新价格
			updatePrice(variant){
				const priceContainer = this.querySelector(`#Price-${this.sectionId} .f-price`);
				if(!priceContainer) return;
				var moneyFormat = theme.money_format;
				if(theme.currency_code_enabled){
					moneyFormat = theme.money_with_currency_format;
				}
				const price = theme.Shopify.formatMoney(variant.price, moneyFormat);
				const comparePrice = theme.Shopify.formatMoney(variant.compare_at_price, moneyFormat);

				if(variant.available == false){
					priceContainer.classList.add('f-price--sold-out');
				}else{
					priceContainer.classList.remove('f-price--sold-out');
				}
				if(variant.compare_at_price > variant.price){
					priceContainer.classList.add('f-price--on-sale');

					const priceBadges = parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)
					const priceEl = priceContainer.querySelector('.f-price__sale .f-price-item--sale');
					const comparePriceEl = priceContainer.querySelector('.f-price__sale .f-price-item--regular');
					const priceBadgesEl = priceContainer.querySelector('.f-price__badges [data-sale-value]');

					priceEl && (priceEl.innerText = price);
					comparePriceEl && (comparePriceEl.innerText = comparePrice);
					priceBadgesEl && (priceBadgesEl.innerText = priceBadges + '%');
				}else{
					priceContainer.classList.remove('f-price--on-sale');
					const el = priceContainer.querySelector('.f-price__regular .f-price-item');
					el.innerText = price;
					
				}
			}

			// 更新库存是否低于阈值文本 和 加购按钮文本
			updateInventory(variant){
				if(!variant.id) return;
				const inventoryContainer = this.querySelector(`#Inventory-${this.sectionId}`);
				const variantOption = this.querySelector(`#Variants-${this.sectionId} option[value="${variant.id}"]`);
				if(!inventoryContainer || !variantOption) return;

				// 当前变体库存数量
				const inventory = Number(variantOption.getAttribute('data-inventory')) ?? 0;
				// 当前变体，缺货时是否可继续销售
				const inventoryPolicy = variantOption.getAttribute('data-inventory-policyy') ?? 'deny';
				// 当前变体是否存在即将到货的库存
				const incoming = Number(variantOption.getAttribute('data-incoming')) ?? 0;
				// 当前变体即将到货时间
				const incomingDate = variantOption.getAttribute('data-next-incoming-date');
				
				// 自定义库存阈值
				const threshold = Number(inventoryContainer.querySelector('[data-product-inventory]')?.getAttribute('data-threshold')) ?? 0;
				// 自定义是否显示进度条
				const showProgress = inventoryContainer.getAttribute('data-show-progress');
				// 自定义是否显示库存转储通知
				const inventoryTransfer = inventoryContainer.getAttribute('data-inventory-transfer');

				// 更新加购按钮文本
				let disable = false;
				let check_against_inventory = !(variant.inventory_management !== "shopify" || inventoryPolicy === 'continue');
				let quantity_rule_soldout = variant.quantity_rule.min > inventory && check_against_inventory
				if(!variant ||
					variant.availability == false 
					|| quantity_rule_soldout
				){
					disable = true;
				}
				this.updateButton(
					disable,
					window.FoxThemeStrings.soldOut
				);

				// 更新库存是否低于阈值文本
				const iconTextEl = inventoryContainer.querySelector('.ql-add .f-inventory--icon-text');
				const iconEl = inventoryContainer.querySelector('.ql-add .f-inventory--icon');
				const textEl = inventoryContainer.querySelector('[data-product-inventory]');
				const progressEl = inventoryContainer.querySelector('f-progress-bar');
				if(variant.inventory_management == "shopify" && inventory <= threshold && inventory >= 0){
					iconTextEl?.classList.add('f-inventory--low');
					textEl && 
					(textEl.innerHTML = inventory > 1 ?
						 theme.lacales.stock_label.other?.replace('{{ count }}', inventory) :
						 theme.lacales.stock_label.one?.replace('{{ count }}', inventory));
					if(showProgress){
						iconEl?.classList.add('hidden');
						progressEl && 
						(progressEl.style.display = 'block');
					}
					else{
						iconEl?.classList.remove('hidden');
						progressEl &&
						(progressEl.style.display = 'none');
					}
				}else{
					iconTextEl?.classList.remove('f-inventory--low');
					textEl && 
					(textEl.innerHTML = theme.lacales.in_stock_label);
					progressEl &&
						(progressEl.style.display = 'none');
				}

				if(!variant.available){
					iconTextEl?.classList.add('hidden');
					progressEl &&
						(progressEl.style.display = 'none');
				}else{
					iconTextEl?.classList.remove('hidden');
				}

				progressEl?.setAttribute('data-quantity', inventory);
				progressEl?.setAttribute('data-show', showProgress);
				progressEl?.init();

				// 库存转储通知
				const li = inventoryContainer.querySelector('[data-incoming-inventory]');
				if(!li) return;
				const secIconTextEl = li.querySelector('.f-inventory--icon-text');
				const incomingTextEl = li.querySelector('.f-js-incoming-text');
				if(inventoryTransfer){
					if(incoming && inventory <= threshold){
						li?.setAttribute('data-show', true);
						secIconTextEl?.classList.add('hidden');
					}else{
						li?.setAttribute('data-show', false);
						secIconTextEl?.classList.remove('hidden');
					}

					if(!incomingTextEl) return;
					if(incomingDate){
						const date = new Date(incomingDate)
						.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
						if(variant.available){
							incomingTextEl.innerHTML = theme.lacales.will_not_ship_until.replace('{{ date }}', date);
						}else{
							incomingTextEl.innerHTML = theme.lacales.will_be_in_stock_after.replace('{{ date }}', date);
						}
					}else{
						incomingTextEl.innerHTML = theme.lacales.waiting_for_stock;
					}
				}

			}

			// 更新Sku
			updateSku(variant){
				const container = this.querySelector(`#Sku-${this.sectionId}`);
				if(!container) return;
				const textEl = container.querySelector('[data-product-sku]');
				textEl && (textEl.innerHTML = variant.sku ?? theme.lacales.no_sku);
			}

			// 更新分享链接 和 Ask question
			updateShareLink(selectedVariant){
				const currentShareModal = document.getElementById(
					`PopupModal-Sharing-${this.sectionId}`
				);

				const currentAskModal = document.getElementById(
					`PopupModal-AskQuestionForm-${this.sectionId}`
				);

				let link = window.shopUrl + this.dataset.productUrl;
				if(selectedVariant) link += '?variant=' + selectedVariant.id;

				// 分享链接
				if(currentShareModal && currentShareModal.querySelector('[data-share-url]')){
					currentShareModal.querySelector('[data-share-url]').value = link;
				}

				// Ask question
				if(currentAskModal && currentAskModal.querySelector('[name="contact[product url]"]')){
					currentAskModal.querySelector('[name="contact[product url]"]').value = window.shopUrl + this.dataset.productUrl;
				}
				if(currentAskModal && currentAskModal.querySelector('[name="contact[product]"]')){
					currentAskModal.querySelector('[name="contact[product]"]').value = this.productData.title;
				}
			}

			handleSwapProduct(productUrl, updateFullPage) {
				return (html) => {
					const selector = updateFullPage
						? "product-info[id^='MainProduct']"
						: "product-info";

					const variant = this.getSelectedVariant(html.querySelector(selector));

					this.updateURL(productUrl, variant?.id);

					if (updateFullPage) {
						// share 分享链接
						const currentShareModal = document.getElementById(
							`PopupModal-Sharing-${this.sectionId}`
						);
						document.querySelector("head title").innerHTML =
							html.querySelector("head title").innerHTML;
						if (currentShareModal) document.body.removeChild(currentShareModal);

						HTMLUpdateUtility.viewTransition(
							document.querySelector("main"),
							html.querySelector("main"),
							this.preProcessHtmlCallbacks,
							this.postProcessHtmlCallbacks
						);
						HTMLUpdateUtility.viewTransition(
							document.getElementById("shopify-section-sticky-atc-bar"),
							html.getElementById("shopify-section-sticky-atc-bar"),
							this.preProcessHtmlCallbacks,
							this.postProcessHtmlCallbacks
						);
					} else {
						HTMLUpdateUtility.viewTransition(
							this,
							html.querySelector("product-info"),
							this.preProcessHtmlCallbacks,
							this.postProcessHtmlCallbacks
						);
					}
				};
			}

			handleUpdateProductInfo(productUrl) {
				return (html) => {
					const variant = this.getSelectedVariant(html);

					this.pickupAvailability?.update(variant);
					this.updateOptionValues(html);
					this.updateURL(productUrl, variant?.id);
					this.updateShareUrl(variant?.id);
					this.updateVariantInputs(variant?.id);
					this.toolTip = __reInitTooltip(this);

					if (!variant) {
						this.setUnavailable();
						return;
					}

					this.updateMedia(variant);
					this.setOotd(variant);

					const updateSourceFromDestination = (id) => {
						const source = html.getElementById(`${id}-${this.sectionId}`);
						const destination = this.querySelector(`#${id}-${this.sectionId}`);
						if (source && destination) {
							destination.innerHTML = source.innerHTML;
							destination.removeAttribute("hidden");
						}
					};

					updateSourceFromDestination("Price");
					updateSourceFromDestination("Volume");
					updateSourceFromDestination("PricePerItem");
					updateSourceFromDestination("Inventory");
					updateSourceFromDestination("Sku");
					updateSourceFromDestination("Availability");

					this.updateQuantityRules(this.sectionId, this.productId, html);
					updateSourceFromDestination("QuantityRules");
					updateSourceFromDestination("QuantityRulesCart");
					updateSourceFromDestination("VolumeNote");

					// 加购按钮
					const addButtonUpdated = html.getElementById(
						`ProductSubmitButton-${this.sectionId}`
					);
					this.updateButton(
						addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
						window.FoxThemeStrings.soldOut
					);
					this.currentVariant = variant;

					window.FoxThemeEvents.emit(PUB_SUB_EVENTS.variantChange, {
						data: { variant, sectionId: this.sectionId, html },
					});

					document.dispatchEvent(
						new CustomEvent("variant:changed", {
							detail: {
								variant: this.currentVariant,
							},
						})
					);
				};
			}

			buildRequestUrlWithParams(
				url,
				optionValues,
				shouldFetchFullPage = false
			) {
				const params = [];

				!shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

				if (optionValues.length) {
					params.push(`option_values=${optionValues.join(",")}`);
				}

				return `${url}?${params.join("&")}`;
			}

			renderProductInfo({ requestUrl, targetId, callback }) {
				this.abortController?.abort();
				this.abortController = new AbortController();
				fetch(requestUrl, { signal: this.abortController.signal })
					.then((response) => response.text())
					.then((responseText) => {
						this.pendingRequestUrl = null;
						const html = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						callback(html);
					})
					.then(() => {
						// set focus to last clicked option value
						document.querySelector(`#${targetId}`)?.focus();
					})
					.catch((error) => {
						if (error.name === "AbortError") {
							console.log("Fetch aborted by user");
						} else {
							console.error(error);
						}
					});
			}

			updateOptionValues(html) {
				const variantSelects = html.querySelector("variant-picker");
				if (variantSelects) {
					HTMLUpdateUtility.viewTransition(
						this.variantSelectors,
						variantSelects,
						this.preProcessHtmlCallbacks
					);
				}
			}

			updateURL(url, variantId) {
				if (this.dataset.updateUrl === "false") return;
				window.history.replaceState(
					{},
					"",
					`${url}${variantId ? `?variant=${variantId}` : ""}`
				);
			}

			updateShareUrl(variantId) {
				if (!variantId) return;
				const shareButton = document.getElementById(
					`ShareButton-${this.dataset.section}`
				);
				if (!shareButton || !shareButton.updateUrl) return;
				shareButton.updateUrl(
					`${window.shopUrl}${this.dataset.productUrl}?variant=${variantId}`
				);
			}

			updateVariantInputs(variantId) {
				document
					.querySelectorAll(
						`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
					)
					.forEach((productForm) => {
						const input = productForm.querySelector('input[name="id"]');
						input.value = variantId ?? "";
						input.dispatchEvent(new Event("change", { bubbles: true }));
					});
			}

			updateButton(disable = true, text) {
				const productForm = document.getElementById(
					`product-form-${this.sectionId}`
				);
				if (!productForm) return;
				const addButton = productForm.querySelector('[name="add"]');
				const addButtonText = productForm.querySelector(
					'[name="add"] > span:not(.f-icon)'
				);

				if (!addButton) return;
				if (disable) {
					addButton.setAttribute("disabled", "disabled");
					if (text) addButtonText.textContent = text;
				} else {
					addButton.removeAttribute("disabled");
					addButtonText.textContent = window.FoxThemeStrings.addToCart;
				}
			}

			// 更新媒体图
			updateMedia(variant) {
				if (!this.productMedia) return;

				this.updateMediaByVariantColor();

				// 媒体图切换
				var currentColor, newMediaVisible = false;
				var targetColor = variant.options[0];
				var gallery = this.productMedia.querySelector(".f-product__media-list")
					, thumbMedia = this.productMedia.querySelector(".f-product__media-thumbnails");
				
				// 隐藏所有媒体图
				var allMediaElements = gallery.querySelectorAll('.f-product__media');
				var allThumbMediaElement = thumbMedia?.querySelectorAll('.f-product__media-thumbnails-item') ?? [];
				allMediaElements.forEach((item) => {
					item.setAttribute('aria-hidden', true);
				});
				allThumbMediaElement.forEach((item) => {
					item.setAttribute('ql-aria-hidden', true);
				});

				// 显示当前选中颜色对应的媒体图
				let allMedias = this.productData?.media ?? [];
				// if(this.allMediasJson.length > 0) allMedias = this.allMediasJson;
				allMedias.forEach((media) => {
					if (this.mediaByVariantColor[media.id]) {
						currentColor = this.mediaByVariantColor[media.id];
					}					
					var mediaElement = gallery.querySelector(".f-product__media[data-media-id=\"".concat(media.id, "\"]"))
						, thumbMediaElement = thumbMedia?.querySelector(".f-product__media-thumbnails-item[data-media-id=\"".concat(media.id, "\"]"));
					if (mediaElement) {
						var showMedia = !!(currentColor && currentColor.includes(targetColor));
						if (mediaElement.getAttribute('aria-hidden') == showMedia.toString()) {
							newMediaVisible = true;
						}
						//Remove images which precede any variant image
						if (!currentColor) {
							mediaElement.remove();
							thumbMediaElement?.remove();
						}

						mediaElement.setAttribute('aria-hidden', !showMedia);
						thumbMediaElement?.setAttribute('ql-aria-hidden', !showMedia);

					}
				});
				this.selectedMedias = this.querySelectorAll('media-gallery:not(.ql_add) .f-product__media[aria-hidden="false"]');
				this.thumbSelectedMedias = this.querySelectorAll('media-gallery:not(.ql_add) .f-product__media-thumbnails-item[ql-aria-hidden="false"]');

				if (this.variantGroupImages && this.variantGroupImages.enable) {
					const isCarousel = this.productMedia.querySelector(".flickity-slider")
						? true
						: false;
					const initalMediaIds = this.productMedia?.domNodes?.medias.map(
						(item) => item.dataset.mediaId
					);
					const groupImages = this.variantGroupImages.mapping.find(
						(item) => Number(item.id) === variant.id
					);
					const currentVariantMedia = groupImages
						? groupImages.media
						: this.allMediaIds;

					if (!this.areArraysEquivalent(currentVariantMedia, initalMediaIds)) {
						const mainMedia = this.productMedia.querySelector(
							".f-product__media-list"
						);
						const thumbMedia = this.productMedia.querySelector(
							".f-product__media-thumbnails"
						);
						if (isCarousel) {
							const mainFlickity = window.FoxTheme.Flickity.data(mainMedia);

							let mediaToRemove =
								mainMedia.querySelectorAll(".f-product__media");
							mediaToRemove &&
								mediaToRemove.forEach(function (slide) {
									mainFlickity.remove(slide);
								});
							let mediaToShow = this.filteredMediaForSelectedVariant(
								this.productMedia.domNodes.medias,
								currentVariantMedia
							);

							mediaToShow.forEach(function (slide, index) {
								const zoomButton = slide.querySelector(".js-photoswipe--zoom");
								if (zoomButton) {
									zoomButton.setAttribute("data-media-index", index);
								}
								slide.setAttribute("data-media-index", index);
								slide.setAttribute("data-index", index);
								mainFlickity.append(slide);
							});

							if (thumbMedia && this.productMedia.domNodes.thumbnailItems) {
								const thumbnailsFlickity =
									window.FoxTheme.Flickity.data(thumbMedia);

								let thumbsToRemove = thumbMedia.querySelectorAll(
									".f-product__media-thumbnails-item"
								);
								thumbsToRemove &&
									thumbsToRemove.forEach(function (slide) {
										thumbnailsFlickity.remove(slide);
									});

								let thumbsToShow = this.filteredMediaForSelectedVariant(
									this.productMedia.domNodes.thumbnailItems,
									currentVariantMedia
								);
								thumbsToShow.forEach(function (slide, index) {
									slide.setAttribute("data-thumbnail-index", index);
									slide.setAttribute("data-index", index);
									thumbnailsFlickity.append(slide);
								});

								thumbMedia.classList.remove(
									"disable-transition",
									"md:disable-transition"
								);
								if (thumbsToShow.length < 5) {
									thumbMedia.classList.add("disable-transition");
								}
								if (thumbsToShow.length < 6) {
									thumbMedia.classList.add("md:disable-transition");
								}
								thumbnailsFlickity.option({
									wrapAround: thumbsToShow.length > 5,
								});
								thumbnailsFlickity.reloadCells();
								thumbnailsFlickity.reposition();
							}

							mainFlickity.select(0, false, false);
						} else {
							let mediaToShow = this.filteredMediaForSelectedVariant(
								this.productMedia.domNodes.medias,
								currentVariantMedia
							);
							mainMedia.innerHTML = "";
							mediaToShow.forEach((item, index) => {
								const zoomButton = item.querySelector(".js-photoswipe--zoom");
								if (zoomButton) {
									zoomButton.setAttribute("data-media-index", index);
								}
								item.setAttribute("data-media-index", index);
								item.setAttribute("data-index", index);
								mainMedia.append(item);
							});
						}

						// Re-init Photoswipe
						if (this.productMedia && this.productMedia.enableZoom) {
							this.productMedia.lightbox &&
								this.productMedia.lightbox.destroy();
							this.productMedia.initImageZoom();
						}
					}

					this.productMedia.removeAttribute("data-media-loading");
				} else {
					if (!variant.featured_media) return;
					if (typeof this.setActiveMedia === "function") {
						this.setActiveMedia(variant.featured_media.id);
					}

				}
			}

			// 更新媒体图坐标
			updateMediaByVariantColor(){
				let allVariants = this.productData?.variants ?? [];
				// if(this.allVariantsJson.length > 0) allVariants = this.allVariantsJson ?? [];
				allVariants.forEach((variant) => {
					if (variant.featured_media) {
						if (!this.mediaByVariantColor[variant.featured_media.id]) {
							this.mediaByVariantColor[variant.featured_media.id] = [];
						}
						// 拿到当前选定swatch的选项值
						this.mediaByVariantColor[variant.featured_media.id].push(variant.options[0]);
					}
				});
			}

			// 模特数据
			_ql_modal_data(product, variant) {
				// 隐藏所有模特数据
				const modelItems = this.querySelectorAll('.ql_model-data .model-item');
				const thisOption = variant.options[0];
				const handle = product.handle;
				modelItems.forEach((item) => {
					item.style.display = 'none';
				});

				if(!handle || !thisOption) return;

				const showEls = this.querySelectorAll(`.ql_model-data .model-item[data-handle="${handle}"][data-value="${thisOption}"]`);
				// const modelBox = this.querySelector('.ql_model-data');
				if(showEls.length > 0){
					showEls.forEach((el) => {
						el.style.display = 'block';
					});
					// modelBox.style.display = 'block';
					// modelBox.style.opacity = 1;
				}
				// else{
				// 	modelBox.style.display = 'none';
				// 	modelBox.style.opacity = 0;
				// }
			}

			// ootd 关联搭配
			async setOotd(variant) {
				const flickityEls = document.querySelectorAll('flickity-component');
				const ootd = this.querySelector('#ql-ootd');
				const ootdTitle = this.querySelector('#ql-ootd-title');
				const ootdContainer = this.querySelector('ootd-container');
				if (!ootdContainer) return;

				// 元字段 ootd数据
				const _ql_ootd_arr = JSON.parse(ootd.querySelector('#_ql_ootd_arr').innerHTML);
				if (_ql_ootd_arr?.length <= 0) return;

				// 隐藏标题和上一次显示的关联搭配产品
				const ootdItems = ootdContainer.querySelectorAll('ootd-item');
				ootdItems.forEach(item => {
					item.style.display = "none";
				});
				ootdTitle.style.display = "none";

				const arr_ootd = _ql_ootd_arr.filter((v, i) => variant.option1 === v.color);
				if (arr_ootd.length <= 0) return;

				// 查找之前是否已渲染过关联的产品
				let hasootdItems = false;
				arr_ootd.forEach(this_ootd => {
					const thisOotdItem = ootdContainer.querySelectorAll(`ootd-item[data-ootd-handle="${this_ootd.ootd_handle}"]`);
					if (thisOotdItem.length > 0) {
						hasootdItems = true;
						thisOotdItem.forEach(item => {
							// 选中指定颜色
							let select = this.querySelector(`.product-card__options .variant-picker__field input[value="${this_ootd.ootd_color}"]`);
							if(!select) return;
							select.checked = true;
							const selectOptions = item.getSelectOptions();
            				item.changeVariantId(selectOptions);

							item.style.display = "block";
						});

						// ootd指定显示complete the look按钮 的 移动端媒体元素
						this.setOotdBtn(this_ootd.img_pos);
					}
				});
				if (hasootdItems) {
					ootdTitle.style.display = "block";
					flickityEls.forEach(flickityEl => {
						flickityEl.update();
					});
					return;
				}

				// 没有渲染关联产品时，ajax请求并插入到页面
				Promise.allSettled(
					arr_ootd.map(this_ootd =>
						fetch(`${window.location.origin}/products/${this_ootd.ootd_handle}?view=card-item`)
							.then((response) => response.text())
					)
				).then(results => {
					const fragment = new DocumentFragment();
					results.forEach((result, i) => {
						const html = new DOMParser().parseFromString(
							result.value,
							"text/html"
						);
						const color = arr_ootd[i].color;
						const ootd_color = arr_ootd[i].ootd_color;
						const handle = arr_ootd[i].handle;
						const ootd_handle = arr_ootd[i].ootd_handle;
						const item = html.querySelector('.ootd-item.product-card');
						if(!item) return;
						const ootdItem = document.createElement('ootd-item')
						ootdItem.setAttribute('data-color', color);
						ootdItem.setAttribute('data-ootd-color', ootd_color);
						ootdItem.setAttribute('data-handle', handle);
						ootdItem.setAttribute('data-ootd-handle', ootd_handle);
						ootdItem.appendChild(item);

						if (item) fragment.appendChild(ootdItem);

						this.setOotdBtn(arr_ootd[i].img_pos);
					});
					ootdContainer.appendChild(fragment);
					if(ootdContainer.querySelectorAll('ootd-item')?.length > 0 ) ootdTitle.style.display = "block";
					ootdContainer.querySelectorAll('ootd-item').forEach((item) => {
						item.init();
					});
					flickityEls.forEach(flickityEl => {
						flickityEl.update();
					});
				});
			}

			// ootd 移动端 指定媒体图显示关联产品的锚点按钮
			setOotdBtn(pos) {
				const mobileMedias = this.querySelectorAll('media-gallery.ql_add .f-product__media responsive-image');
				if (mobileMedias.length <= 0) return;
				const mobileOotdMedia = mobileMedias[pos - 1];
				const aEl = document.createElement('a');
				aEl.setAttribute('href', '#ql-ootd-anchor');
				aEl.setAttribute('class', 'ql-ootd-link btn');
				aEl.innerHTML = 'complete the look';
				mobileOotdMedia.appendChild(aEl);
			}

			setActiveMedia(mediaId) {
				const selectedMedia = this.productMedia.domNodes.mediaGallery.querySelector(
					`[data-media-id="${mediaId}"]`
				);
				if (!selectedMedia) return;
				const mediaIndex = Number(selectedMedia.dataset.mediaIndex);
				const quickView = this.firstElementChild?.classList.contains('f-product-quickview')
								|| this.dataset.sectionType === "featured-product";


				if (this.mediaLayout === "carousel") {
					this.productMedia.mediaGallery &&
						this.productMedia.mediaGallery.select(mediaIndex, false, true);
				}
				else if (FoxThemeSettings.isMobile || quickView) {
					this.querySelector("media-gallery.ql_add")?.remove();
					// const medias = this.querySelectorAll('media-gallery:not(.ql_add) .f-product__media.is-selected,media-gallery:not(.ql_add) .f-product__media[aria-hidden="false"]');

					const flickity_counter_clone = this.productMedia.querySelector(".flickity-page-counter").cloneNode(!0);
					let media_gallery_clone = this.productMedia.cloneNode(!0);
					let is_layout_carousel = "carousel" === this.productMedia.mediaLayout, mediaList,
						thumb_gallery = media_gallery_clone.querySelector(".f-product__media-thumbnails-wrapper flickity-component");
					if (flickity_counter_clone.querySelector(".flickity-counter--current").innerText = 1,
						flickity_counter_clone.querySelector(".flickity-counter--total").innerText = this.selectedMedias.length,
						media_gallery_clone.querySelector("[data-media-viewer] flickity-component").innerHTML = flickity_counter_clone?.outerHTML,
						mediaList = media_gallery_clone.querySelector('[data-media-viewer] flickity-component'),
						quickView && (mediaList.innerHTML = ''),
						this.selectedMedias.forEach((element, index) => {
							const e = element.cloneNode(true);
							e.setAttribute('data-media-index', index);
							e.setAttribute('aria-hidden', false);
							mediaList.appendChild(e);
						}),
						media_gallery_clone.classList.add("ql_add"),
						quickView && (media_gallery_clone.classList.add("ql_quick-view"),
							(thumb_gallery.innerHTML = ''),
							this.thumbSelectedMedias.forEach((element, index) => {
								const e = element.cloneNode(true);
								e.setAttribute('data-thumbnail-index', index);
								e.setAttribute('ql-aria-hidden', false);
								thumb_gallery.appendChild(e);
							})
						),


						media_gallery_clone.classList.remove("hidden"),
						media_gallery_clone.classList.remove("mb:block"),

						this.productMedia.parentElement.appendChild(media_gallery_clone),
						media_gallery_clone = this.querySelector("media-gallery.ql_add"),
						is_layout_carousel
					) {
						let main_gallery = media_gallery_clone.querySelector("[data-media-viewer] flickity-component");

						if (quickView) {
							thumb_gallery = media_gallery_clone.querySelector(".f-product__media-thumbnails-wrapper flickity-component");
							let thumb_options = JSON.parse(thumb_gallery.getAttribute("data-slider-options"));
							let f = thumb_options.setGallerySize = this.thumbSelectedMedias.length > 5 ? false : true;


							thumb_options =
							{
								asNavFor: ".ql_add #Media-Gallery-product-quickview",
								contain: true,
								pageDots: false,
								cellAlign: "left",
								setGallerySize: false,
								wrapAround: !f
							};


							thumb_gallery.setAttribute("data-slider-options", JSON.stringify(thumb_options));
							// thumb_gallery?.initSlider();
						}
						try {
							main_gallery.destroy(),
								thumb_gallery?.destroy()
						} catch (err) { }
						main_gallery.initSlider();
						// thumb_gallery?.initSlider();

					}

					let modal_gallery = this.querySelector("flickity-component")
					"function" == typeof modal_gallery.connectedCallback && modal_gallery.connectedCallback()

				} else {
					this.productMedia.scrollIntoView(selectedMedia);
				}
			}

			setUnavailable() {
				this.updateButton(true, window.FoxThemeStrings.unavailable);

				const selectors = [
					"Price",
					"Inventory",
					"Sku",
					"PricePerItem",
					"VolumeNote",
					"Volume",
					"QuantityRules",
					"QuantityRulesCart",
				]
					.map((id) => `#${id}-${this.sectionId}`)
					.join(", ");
				document
					.querySelectorAll(selectors)
					.forEach((selector) => selector.setAttribute("hidden", ""));
			}

			areArraysEquivalent(firstArray, secondArray) {
				if (!Array.isArray(firstArray) || !Array.isArray(secondArray)) {
					return false;
				}

				if (firstArray.length !== secondArray.length) {
					return false;
				}

				const sortedFirstArray = [...firstArray].sort();
				const sortedSecondArray = [...secondArray].sort();

				return sortedFirstArray.every(
					(value, index) => value === sortedSecondArray[index]
				);
			}

			filteredMediaForSelectedVariant(items, currentVariantMedia) {
				let index = 0;
				let prioritizedResults = [];
				let otherResults = [];
				items.forEach((item) => {
					const dataIdMedia = item.dataset.mediaId;
					if (currentVariantMedia && currentVariantMedia.length > 0) {
						if (currentVariantMedia.includes(dataIdMedia)) {
							item.dataset.index = index++;
							prioritizedResults.push(item);
						}

						if (item.dataset.mediaType !== "image") {
							item.dataset.index = index++;
							otherResults.push(item);
						}
					} else {
						item.dataset.index = index++;
						prioritizedResults.push(item);
					}
				});

				const sortByVariantOrder = (a, b) => {
					const indexA = currentVariantMedia.indexOf(a.dataset.mediaId);
					const indexB = currentVariantMedia.indexOf(b.dataset.mediaId);
					return indexA - indexB;
				};

				prioritizedResults.sort(sortByVariantOrder);

				const results = [...prioritizedResults, ...otherResults];

				return results;
			}

			initQuantityHandlers() {
				if (!this.quantityInput) return;

				this.setQuantityBoundries();
				if (!this.hasAttribute("data-original-section-id")) {
					this.cartUpdateUnsubscriber = FoxThemeEvents.subscribe(
						PUB_SUB_EVENTS.cartUpdate,
						this.fetchQuantityRules.bind(this)
					);
				}
			}

			setQuantityBoundries() {
				FoxThemeEvents.emit(PUB_SUB_EVENTS.quantityBoundries, {
					data: {
						sectionId: this.sectionId,
						productId: this.productId,
					},
				});
			}

			fetchQuantityRules() {
				const currentVariantId = this.productForm?.variantIdInput?.value;
				if (!currentVariantId) return;

				fetch(
					`${this.getAttribute(
						"data-product-url"
					)}?variant=${currentVariantId}&section_id=${this.sectionId}`
				)
					.then((response) => response.text())
					.then((responseText) => {
						const parsedHTML = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						this.updateQuantityRules(
							this.sectionId,
							this.productId,
							parsedHTML
						);
					})
					.catch((error) => {
						console.error(error);
					})
					.finally(() => { });
			}

			updateQuantityRules(sectionId, productId, parsedHTML) {
				if (!this.quantityInput) return;

				FoxThemeEvents.emit(PUB_SUB_EVENTS.quantityRules, {
					data: {
						sectionId,
						productId,
						parsedHTML,
					},
				});

				this.setQuantityBoundries();
			}
		}
	);
}
